import React from 'react';
import FooterBreadCrumb from '../../components/common-footer/FooterBreadCrumb';

const PrivacyPolicy = () => {
  // Desktop View
  return (
    <div className="privacy-policy announcement-list-page">
      <div className="privacy-policy-page">

        {/* Main Content */}
        <main className="main-content">

          {/* Breadcrumb */}
          <FooterBreadCrumb heading="개인정보취급방침" />
           <div className="outer-box">

          <div className="content-container">

            <div className="privacy-text">
              <h2>개인정보의 수집,이용목적</h2>
              <p>
                ① 서비스 이용에 따른 본인식별, 실명확인, 가입의사확인, 연령제한 서비스이용<br />
                ② 고지사항 전달, 불만처리 의사소통 경로 확보, 물품배송 시 정확한 배송지 정보 확보<br />
                ③ 신규 서비스등 최신정보 안내 및 개인맞춤서비스 제공을 위한 자료<br />
                ④ 유료정보 이용에 대한 요금결제<br />
                ⑤ 불량회원 부정이용 방지 및 비인가 사용방지<br />
                ⑥ 기타 원활한 양질의 서비스 제공등
              </p>

              <h2>수집하는 개인정보의 항목</h2>
              <p>
                ① 성명, 주민번호, 생년월일, 아이디, 비밀번호, 이메일주소, 전화번호, 계좌번호, IP정보, 그외 선택항목
              </p>

              <h2>개인정보의 보유 및 이용기간</h2>
              <p>
                ① 원칙적으로 개인정보의 수집 또는 제공받는 목적 달성시 지체 없이 파기합니다.<br />
                ② 단, 불량회원의 부정이용 재발 방지를 위해 이용계약 해지 후 주민번호 및 아이디를 3개월간 보유할 수 있으며<br />
                ③ 전자상거래에서의 소비자보호에 관한 법률 등 타법률에 의해 보존할 필요가 있는 경우에는 일정기간 보존합니다.
              </p>
            </div>
          </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 